import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router-dom';

import { Form, FormGroup, Label } from 'reactstrap';

import './RecapReport.scss' ;

import RecapReportHeader from './RecapReportHeader';
import RecapReportIntervals from './RecapReportIntervals';

import { EInput } from 'src/Components/EInput';

@inject('stores')
@observer
class RecapReport extends React.Component {
    public props: any;
    private recap: any;
    public WellsStore: any;

    public state = {
        recap: this.recap,
        type: 'both'
    };

    constructor(props: any) {
        super(props);

        this.WellsStore = this.props.stores.WellsStore;

        this.handleRadioSelect = this.handleRadioSelect.bind(this);
    }

    public componentWillMount() {
        this.getWellRecap();
    }

    private getWellRecap() {
        return this.WellsStore.getWellRecap(this.props.match.params.wellId, this.state.type)
        .then(
            (data: any) => {
                this.setState({
                    recap: data
                });
            }
        );
    }

    private handleRadioSelect(event: any) {
        this.setState({
            type: event.target.value
        }, () => {
            this.getWellRecap();
        });
    }

    public render() {
        return(
            <div className="RecapReport">
                <Form className="typeForm">
                    <Label>Tests to include on Recap Report:</Label><br/>
                    <FormGroup check={true} inline={true}>
                        <Label check={true}>
                        <EInput
                            type="radio"
                            name="testType"
                            value="oil"
                            onChange={this.handleRadioSelect}
                            checked={this.state.type === 'oil' ? true : false}
                        />
                        </Label> Oil
                    </FormGroup>
                    <FormGroup check={true} inline={true}>
                        <Label check={true}>
                        <EInput
                            type="radio"
                            name="testType"
                            value="water"
                            onChange={this.handleRadioSelect}
                            checked={this.state.type === 'water' ? true : false}
                        />
                        </Label> Water
                    </FormGroup>
                    <FormGroup check={true} inline={true}>
                        <Label check={true}>
                        <EInput
                            type="radio"
                            name="testType"
                            value="both"
                            onChange={this.handleRadioSelect}
                            checked={this.state.type === 'both' ? true : false}
                        />
                        </Label> Both
                    </FormGroup>
                </Form>
                <RecapReportHeader recap={this.state.recap}/>
                <RecapReportIntervals recap={this.state.recap}/>
            </div>
        );
    }
}

export default withRouter(RecapReport);



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/RecapReport/RecapReport.tsx